module.exports = __webpack_public_path__ + "static/media/image (24).086d67f8.jpg";